<template>
  <div id="app">
    <router-view class="router_view" />
    <div v-if="bottomShow == 1" class="ICP w100 lh36 fs12 c9 flex_center">
      <span>上海崇齐网络科技有限公司</span>
      <a class="linkba c9 ml20" href="http://beian.miit.gov.cn/">沪ICP备2020038367号-2</a>
      <img src="@/assets/jh.png" class="ml20 mr8">
      <span>沪公网安备 2020038367号</span>
    </div>
    <div v-else class="ICP w100 lh36 fs12 c9 flex_center">
      <span>上海浦星拓扑科技有限公司</span>
      <a class="linkba c9 ml20" href="http://beian.miit.gov.cn/">沪ICP备2021029403号-1</a>
      <!-- <img src="@/assets/jh.png" class="ml20 mr8">
      <span>沪公网安备 2021029403号</span> -->
    </div>
  </div>
</template>

<script>
import { isPuXing } from '@/utils/fn'
export default {
  name: 'App',
  data() {
    return {
      bottomShow: isPuXing() ? 2 : 1
    }
  }
}
</script>
<style lang="scss" scoped>
#app{
  background-color: #f5f5f5;
  // user-select: none;
  // -moz-user-select: none;
  // -webkit-user-select: none;
  // -ms-user-select: none;
}
.ICP{
  position: fixed;
  left: 0;
  // background: #F5F9FF;
  background: #F5F5F5;
  bottom: 0;
  .linkba:hover{
    color: #666;
    text-decoration: underline;
  }
}
.router_view{
  height: calc(100% - 36px);
}
.el-main{
  padding: 0;
}
</style>
